/** @format */

import React, { useState, useEffect } from 'react'
import { _$, Dialog, Button, Select, Option } from '@king-design/react'
import MonitorSearch from 'src/components/MonitorSearch'
import useTableGroup from 'src/hooks/useTableGroup'
import TablePage from 'src/components/TablePage'
import useFormTable from 'src/hooks/useFormTable'
import styled from 'styled-components'
import { API } from 'src/api/ApiAlarmServer'
import { QueryKeyEnum } from 'src/utils/unit'

interface TacticsInstancesDialogProps {
  className?: string
  visible: boolean
  policyId: number
  projectName: string
  onClose: (value: boolean) => void
}

type QueryKey = 'InstanceId' | 'InstanceName' | 'InstanceIP'

const TacticsInstancesDialog: React.FC<TacticsInstancesDialogProps> = ({
  className,
  visible,
  policyId,
  projectName,
  onClose
}) => {
  const [queryKey, setQueryKey] = useState<QueryKey>('InstanceId')
  const [query, setQuery] = useState<string>('')
  const regionGroup = useTableGroup('monitorRegionList')
  const [tableGroup, setTableGroup] = useState<{ region: string }>({ region: '' })
  const [tableData, setTableData] = useState<any[]>([])
  const [tablepProp, setTableProp] = useState<boolean>(false)

  useEffect(() => {
    if (visible && policyId) {
      run({
        PageIndex: 1,
        PageSize: 10
      })
    } else {
      setQuery('')
      setQueryKey('InstanceId')
      setTableGroup({ region: '' })
      setTableData([])
    }
  }, [visible])

  const { run, result, total, pageState, loading }: any = useFormTable(
    API.GetPolicyInstances,
    {
      manual: true,
      params: {
        PolicyId: policyId,
        Region: tableGroup.region,
        [queryKey]: query
      }
    },
    data => {
      return {
        tableData: data?.resourceList,
        totalCount: data?.totalCount
      }
    }
  )

  useEffect(() => {
    if (visible && result) {
      setTableData(result || [])
      const setTablePropFind = result?.find(item => {
        return item.properties?.length
      })
      setTableProp(!!setTablePropFind)
    }
  }, [result])

  const getScheme = () => {
    const tableScheme = {
      instanceName: {
        title: _$('实例名称'),
        width: 200
      },
      instanceIP: {
        title: _$('IP地址'),
        width: 150
      },
      properties: {
        title: _$('备注'),
        template({ properties }) {
          return properties?.length
            ? properties.map(({ name, value }) =>
                name && value ? (
                  <p key={`${name}：${value}`} style={{ margin: 0 }}>
                    {name}：{value}
                  </p>
                ) : (
                  ''
                )
              )
            : ''
        }
      },
      region: {
        title: _$('region'),
        width: 150,
        group: regionGroup,
        template(item) {
          const find = regionGroup.find(({ value }) => item.region === value)
          return find?.label || item.region
        }
      }
    }
    if (!tablepProp) {
      delete tableScheme.properties
    }
    return tableScheme
  }

  return (
    <Dialog
      width={800}
      value={visible}
      mode="destroy"
      onChangeValue={show => {
        !show && onClose(show)
      }}
      title={projectName ? `${_$('已绑实例')} - ${projectName}` : _$('已绑实例')}
      slotFooter={
        <>
          <Button
            type="primary"
            onClick={() => {
              onClose(false)
            }}
          >
            {_$('关闭')}
          </Button>
        </>
      }
    >
      <div className={className}>
        <div className="header">
          <MonitorSearch
            prepend={
              <React.Fragment>
                <Select
                  value={queryKey}
                  onChangeValue={value => {
                    setQueryKey(value)
                    run({
                      PageIndex: 1,
                      InstanceId: '',
                      InstaceName: '',
                      InstanceIP: '',
                      [value]: query
                    })
                  }}
                  width="120"
                >
                  <Option value="InstanceId">{_$('实例ID')}</Option>
                  <Option value="InstanceName">{_$('实例名称')}</Option>
                  <Option value="InstanceIP">{_$('实例信息')}</Option>
                </Select>
              </React.Fragment>
            }
            width={350}
            placeholder={_$(`请输入${QueryKeyEnum[queryKey]}`)}
            value={query}
            onChange={value => {
              setQuery(value.trim())
              run({
                PageIndex: 1,
                InstanceId: '',
                InstaceName: '',
                InstanceIP: '',
                [queryKey]: value.trim()
              })
            }}
          />
        </div>

        <TablePage
          tableProps={{
            scheme: getScheme(),
            data: tableData,
            checkType: 'none',
            resizable: true,
            group: tableGroup,
            onChangeGroup: value => {
              setTableGroup(value)
              run({
                PageIndex: 1,
                Region: value.region
              })
            }
          }}
          run={run}
          loading={loading}
          pageProps={{ total, ...pageState }}
        />
      </div>
    </Dialog>
  )
}

export default styled(TacticsInstancesDialog)``
